import { useEffect, useState, useContext } from 'react';
import React from 'react';
// import logo from './logo.svg';
import './App.css';
import './css/sb-admin-2.min.css'
import {  Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
import Login from './Screens/Login';
// import Home from './Screens/Home';
import ViewCustomers from './Screens/ViewCustomers';
import AddCustomer from './Screens/AddCustomer';
import Dashboard from './Screens/Dashboard';
import { Context, Provider } from "./Context/DataContext";
// import AddOrder from './Screens/AddOrder';
import ViewOrder from './Screens/ViewOrder';
import AddProduct from './Screens/AddProduct';
import ViewProducts from './Screens/ViewProducts';
import 'bootstrap/dist/js/bootstrap.bundle';
// import { Modal } from 'react-bootstrap';
// import { AppColors } from './css/AppColors';

import Notfound from './Screens/Notfound';

import AddPresciption from './Screens/AddPrescription';
import ManagePrescription from './Screens/ManagePrescription';
import EditPrescription from './Screens/EditPrescription';
import EditCustomer from './Screens/EditCustomer';
import EditProduct from './Screens/EditProduct';
import ViewSingleCust from './Screens/ViewSingleCust';
import ViewSingleProd from './Screens/ViewSingleProd';
import ViewSinglePresc from './Screens/ViewSignglePresc';
import AddPromotion from './Screens/AddPromotion';
import ManagePromotion from './Screens/ManagePromotion';
import ViewPromotion from './Screens/ViewPromotion';
import EditPromotion from './Screens/EditPromotion';
import AddOrder1 from './Screens/AddOrder1';
import OrderDetails from './Screens/OrderDetails';
import EditOrder from './Screens/EditOrder';
import ReOrder from './Screens/ReOrder';
import AddManufactur from './Screens/AddManufacturer';
import ViewManufactur from './Screens/ViewManufactur';
import EditManufactur from './Screens/EditManufactur';
import AddProdExpiry from './Screens/AddProdExpiry';
import ViewExpiries from './Screens/ViewExpiries';
import EditProdExpiries from './Screens/EditProdExpiries';




const useForceUpdate = () => {
  const [, updateState] = React.useState();
  return React.useCallback(() => updateState({}), []);
}


function getAuthStatus() {
  const status = localStorage.getItem('store_data') ? true : false
  return status
}




const SecuredRoute = (props) => {
  const {  setStoreData } = useContext(Context)
  const forceUpdate = useForceUpdate()
  const [loading, setLoading] = useState(false)


  useEffect(() => {

    // localStorage.removeItem('store_data')
    setStoreData();
    forceUpdate();
    setLoading(true)
  }, [])

  if (!loading) return null

  return (
    <Route path={props.path} render={data => getAuthStatus() ?
      (<props.component {...data}></props.component>) : (<Redirect to={{ pathname: "/" }}></Redirect>)
    }
    ></Route>
  )
}


function App() {


  return (
    <Provider>

      <BrowserRouter>
        
        <Switch>


          <Route exact path="/" component={Login} />
          <Route exact path="/login" component={Login} />
          <Route path='/reOrder/:oi_id/:cust_id/:p_id/:st_id' component={ReOrder} />
          {/* <Route path="/reOrder/:cust_id/" component ={ReOrder} /> */}





          <SecuredRoute path='/dashboard' component={Dashboard} />
          <SecuredRoute path='/viewCustomers' component={ViewCustomers} />
          <SecuredRoute path='/viewProducts' component={ViewProducts} />
          <SecuredRoute path='/viewOrder' component={ViewOrder} />
          <SecuredRoute path='/orderDetails' component={OrderDetails} />
          <SecuredRoute path='/viewPromotion' component={ViewPromotion} />
          <SecuredRoute path='/viewManufactur' component={ViewManufactur} />
          <SecuredRoute path='/viewExpiries' component={ViewExpiries} />


          <SecuredRoute path='/ViewSingleCust' component={ViewSingleCust} />
          <SecuredRoute path='/ViewSingleProd' component={ViewSingleProd} />
          <SecuredRoute path='/ViewSinglePresc' component={ViewSinglePresc} />


          <SecuredRoute path='/addCustomer' component={AddCustomer} />
          <SecuredRoute path='/addOrder' component={AddOrder1} />
          <SecuredRoute path='/addProduct' component={AddProduct} />
          <SecuredRoute path='/addPresciption' component={AddPresciption} />
          <SecuredRoute path='/addPromotion' component={AddPromotion} />
          <SecuredRoute path='/addManufactur' component={AddManufactur} />
          <SecuredRoute path='/addProdExpiry' component={AddProdExpiry} />

          <SecuredRoute path='/editCustomer' component={EditCustomer} />
          <SecuredRoute path='/editPrescription' component={EditPrescription} />
          <SecuredRoute path='/editProduct' component={EditProduct} />
          <SecuredRoute path='/editPromotion' component={EditPromotion} />
          <SecuredRoute path='/editOrder' component={EditOrder} />
          <SecuredRoute path='/editManufactur' component={EditManufactur} />
          <SecuredRoute path='/editProdExpiries' component={EditProdExpiries} />


          <SecuredRoute path='/managePrescription' component={ManagePrescription} />
          <SecuredRoute path='/managePromotion' component={ManagePromotion} />

          <Route component={Notfound} />







        </Switch>
      </BrowserRouter>


    </Provider>

  );


}

export default App;
